// extracted by mini-css-extract-plugin
export default {"main":"OpportunityCreationPanel_main__VkKOe","container":"OpportunityCreationPanel_container__bieAS","footer":"OpportunityCreationPanel_footer__KYdrM"};